import React, {FC} from 'react';
import '/site/parts/block-qr-links/block-qr-links.scss'
import QrLink from "/react4xp/parts/block-qr-links/components/qr-link";

const BlockQrLinks: FC = (props: any) => {
    return (
        <div className="block-qr-links">
            {props.links && props.links.map(x => <QrLink link={x} />)}
        </div>
    );
};

export default BlockQrLinks;
